import { useEffect } from 'react'

import { applyUiPreferences, useUiStore } from '@/shared/stores/ui-store'

/**
 * Sincroniza el store con los atributos del `<html>`.
 *
 * El primer valor ya lo puso el script inline de `index.html`; esto cubre los
 * cambios posteriores y el caso de rehidratacion desde otra pestana.
 */
export function useApplyUiPreferences(): void {
  const theme = useUiStore((state) => state.theme)
  const density = useUiStore((state) => state.density)

  useEffect(() => {
    applyUiPreferences(theme, density)
  }, [theme, density])
}
